import store from '../../vuex/store'
import router from '../../config/routes'
import $ from 'jquery'

/**
 * 处理用户默认会话行为
 */
export default {
	/**
	 * 初始化会话信息
	 * @return {[type]} [description]
	 */
	init: function() {
		//刷新accessToken
		store.dispatch('authFlushAccessToken');
		this.vadToken();
	},
	/**
	 * 验证会话
	 * @return {[type]} [description]
	 */
	vadToken: function() {
		//初始化accessToken
		let tokenId = store.getters.auth_tokenId;
		var obj = this;
		$.ajax({
			url: '/ws/oauth/vad',
			type: 'GET',
			async: false, //同步请求
			beforeSend: function(request) {
				request.setRequestHeader('Authorization', "Bearer " + tokenId);
				request.setRequestHeader('w-client', 'bus');
			},
			success: function(data,textStatus,jqXHR){
				if(data.meta.code == 0) {
					obj.initUserContext();
				} else {
					store.dispatch('authLogout');
					window.location.href = 'login.html';
				}
			},
			error:function(xhr,textStatus){
				store.dispatch('authLogout');
				window.location.href = 'login.html';
			}
		});
	},
	/**
	 * 初始化用户信息
	 * @return {[type]} [description]
	 */
	initUserContext: function() {
		let tokenId = store.getters.auth_tokenId;
		$.ajax({
			url: '/ws/sys/usercontext',
			type: 'GET',
			async: false, //同步请求
			beforeSend: function(request) {
				request.setRequestHeader('Authorization', "Bearer " + tokenId);
				request.setRequestHeader('w-client', 'bus');
			},
			success: function(data,textStatus,jqXHR){
				if(data.meta.code == 0) {
					store.dispatch('authLogin', data.data);
				} else {
					store.dispatch('authLogout');
					window.location.href = 'login.html';
				}
			},
			error:function(xhr,textStatus){
				store.dispatch('authLogout');
				window.location.href = 'login.html';
			}
		});			
	}
}


// WEBPACK FOOTER //
// ./src/view/index/context.js